// Persists a list component's visible-column selection across visits. The URL query
// param remains the source of truth for the current session (shareable/bookmarkable
// links keep working); localStorage is only the fallback used to seed a fresh visit.

export function loadVisibleColumns(
  storageKey: string,
  queryParamValue: string | null | undefined,
  allColumnKeys: string[],
  defaults: string[],
): string[] {
  const fromQuery = queryParamValue?.split(',').filter((k) => allColumnKeys.includes(k));
  if (fromQuery?.length) return fromQuery;

  try {
    const raw = localStorage.getItem(storageKey);
    const parsed: unknown = raw ? JSON.parse(raw) : null;
    if (Array.isArray(parsed)) {
      const fromStorage = parsed.filter((k): k is string => typeof k === 'string' && allColumnKeys.includes(k));
      if (fromStorage.length) return fromStorage;
    }
  } catch {
    // localStorage unavailable (e.g. private mode) — fall through to defaults.
  }

  return defaults;
}

export function saveVisibleColumns(storageKey: string, columns: string[]): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(columns));
  } catch {
    // localStorage unavailable — visibility simply won't persist.
  }
}
